import { getPlayerId } from './playerId';

const fetch = require("node-fetch");

// A one-off UI-engagement beacon (mute button used, player scrolled) -
// sent immediately rather than batched through middleware/actionLogger,
// since these matter even for a player who never solves a joke (that
// batch only ever flushes on solve-and-advance).
export function logUsageEvent(event_type, joke_id, value) {
  fetch('/api/log_usage_event', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      event_type, joke: joke_id || null, player: getPlayerId(),
      value: value === undefined ? null : value,
    }),
  }).catch(() => {
    // best-effort logging - a failed/offline request shouldn't block gameplay
  });
}

// true once this real page load's performance has been reported - a
// module-level (not component-instance) flag, since switching between
// client-side routes (/, /joke/:id, /profile, ...) remounts whichever
// top-level component owns that route without a real page load, and each
// of those mount hooks calls reportPageLoadPerformance defensively in
// case theirs is the very first one (e.g. a bookmarked /profile)
let page_performance_reported = false;

// Reports two numbers, once per real page load (not per SPA route
// change): full page load time (Navigation Timing) and largest
// contentful paint (the most user-perceived "did it feel fast" metric) -
// lets the effect of bundle-size/gzip work actually be measured against
// real visitors instead of just assumed.
export function reportPageLoadPerformance(joke_id) {
  if (page_performance_reported || typeof window === 'undefined' || !window.performance) {
    return;
  }
  page_performance_reported = true;
  try {
    // this app's own JS typically mounts and runs componentDidMount
    // *before* the browser's load event (images/media can still be
    // in flight) - loadEventEnd reads as 0 until load actually fires, so
    // wait for it instead of reading Navigation Timing synchronously here
    const report_load_time = () => {
      // loadEventEnd is only finalized once the load event has fully
      // finished dispatching - reading it synchronously from a 'load'
      // listener (or right as readyState flips to 'complete') can still
      // see it as 0, so push the read to the next tick
      setTimeout(() => {
        const [nav] = performance.getEntriesByType('navigation');
        if (nav && nav.loadEventEnd > 0) {
          logUsageEvent('page_load_seconds', joke_id, nav.loadEventEnd / 1000);
        }
      }, 0);
    };
    if (document.readyState === 'complete') {
      report_load_time();
    } else {
      window.addEventListener('load', report_load_time, { once: true });
    }
  } catch (error) {
    // best-effort - a Navigation Timing quirk shouldn't block gameplay
  }
  try {
    if (typeof PerformanceObserver === 'undefined') {
      return;
    }
    const observer = new PerformanceObserver((list) => {
      const entries = list.getEntries();
      const last = entries[entries.length - 1];
      if (last) {
        logUsageEvent('page_lcp_seconds', joke_id, last.startTime / 1000);
      }
      observer.disconnect();
    });
    observer.observe({ type: 'largest-contentful-paint', buffered: true });
  } catch (error) {
    // LCP isn't supported in every browser - skip it there
  }
}
